import React, {ReactNode} from "react";
import {PktLinkCard} from "@oslokommune/punkt-react";
import {config} from "../../environment";
import {AVSLUTT_PRIS_SØKNAD_ROUTE, OPPSIGELSE_ROUTE, PERMISJON_ROUTE, PLASS_SOKNAD_BASE,} from "../../routes";
import {ResoknadStatus} from "../../api/resoknadstatus";

interface Props {
  resoknadMedlemskap: ResoknadStatus | undefined;
}

export function InnloggetHandlinger({resoknadMedlemskap}: Props) {
  const skjema440Url = config.link440Skjema
  const fakuraAppUrl = config.linkFakturaApp
  const familieopplysningerUrl = config.linkIstFamilieopplysninger

  return (
    <div>
      <h2 className={'pkt-txt-22 mb-size-20'}>Du er logget inn og kan også</h2>
      <div className={"mx-size-8 mx-size-64--tablet-up"}>
        <div className={"pkt-grid"}>
          <LinkCard title={"Søke eller bytte barnehageplass"} href={PLASS_SOKNAD_BASE}
                    iconName={"swingset"}>
            Søk om plass for første gang eller søk om å bytte til en annen barnehage.
          </LinkCard>
          <LinkCard title={"Si opp plassen"} href={OPPSIGELSE_ROUTE}
                    iconName={"stroller-prohibited"}>
            Husk å si opp plassen hvis barnet har byttet til eller fra en privat barnehage.
          </LinkCard>
          <LinkCard title={"Søke om permisjon"} href={PERMISJON_ROUTE}
                    iconName={"obstacle"}>
            Søk om permisjon fra barnehagen i inntil ett år. Private barnehager kan ha egne regler.
          </LinkCard>

          <LinkCard title={"Se faktura"} href={fakuraAppUrl} iconName={"document-text"}>
            Se alle fakturaene dine fra Oslo kommune.
          </LinkCard>
          <LinkCard title={"Søke om redusert pris"} href={skjema440Url} iconName={"invoice"}>
            Familier med lav inntekt kan betale mindre for barnehageplassen.
          </LinkCard>
          <LinkCard title={"Endre familieopplysninger"} href={familieopplysningerUrl} iconName={"home"}>
            Endre opplysninger om foresatte og barn, legg til adresser, endre kontaktinformasjon.
          </LinkCard>
          {resoknadMedlemskap === "AKTIV" && (
            <LinkCard title={"Stoppe søknader om redusert pris"} href={AVSLUTT_PRIS_SØKNAD_ROUTE}
                      iconName={"cross-circle"}>
              Gi oss beskjed hvis dere ikke har behov for redusert pris lenger.
            </LinkCard>
          )}
        </div>
      </div>
    </div>
  )
}

type LinkCardProps = {
  title: string
  href: string
  iconName: string
  children: ReactNode
}

function LinkCard({title, href, iconName, children}: LinkCardProps) {
  return (
    <PktLinkCard className={'pkt-cell pkt-cell--span12 pkt-cell--span6-tablet-big-up'}
                 title={title}
                 iconName={iconName}
                 href={href}
                 skin={"gray-outline"}>
      {children}
    </PktLinkCard>
  )
}

